// eslint-disable-next-line banned-modules
'use strict';

import './style.less';
import BaseView from '@/classes/base.view.js';
import ItemView from './itemView';
import template from './template.ejs';

export default BaseView.extend({

	template,

	events: {
		'click .b-selection__more': 'toggleMore',
	},

	ui: {
		items: '.b-selection__values',
		more: '.b-selection__more',
		attribute: '.b-selection__attribute',
	},

	initialize() {
		this.render();
		this.listenTo(this.model.get('values'), 'add', (item) => {
			this.ui.items.append(new ItemView({
				model: item,
			}).$el);
		});
	},

	render(...args) {
		BaseView.prototype.render.apply(this, args);

		this.values = _.isFunction(this.model.formatter) ? this.model.formatter(this.model.get('values')) : null;
		this.values = this.values || this.model.get('values');

		this.values.each((item) => {
			this.ui.items.append(new ItemView({
				model: item,
				disabled: _.size(this.values) === 1,
			}).$el);
		});

		this.toggleMore();
	},

	// EVENTS
	toggleMore(e) {
		if (e != null) {
			e.preventDefault();
		}

		if (this.ui.more.hasClass('collapsed')) {
			const {options = {}} = this.model;
			const limits = parseInt(options.limits, 10);
			if (!_.isNaN(limits) && this.values.length > limits) {
				this.ui.items.children().slice(limits).hide();
				this.ui.more.removeClass('dn collapsed').text(options.limitLabel || L10N.get('pages.hotels.hotel_selection.more'));
			}
		} else {
			this.ui.items.children().show();
			this.ui.more.addClass('collapsed').text(L10N.get('pages.hotels.hotel_selection.hide'));
		}
	},

});
